import React, {Suspense, useEffect, useRef, useState} from "react";
import {Canvas, useFrame, useThree} from "@react-three/fiber";
import { OrbitControls, useGLTF, useProgress } from "@react-three/drei";
import "../styles/ContactPage.css";
import { FaLinkedin, FaGithub, FaDiscord, FaEnvelope } from "react-icons/fa";

const Model = () => {
    const gltf = useGLTF(`${process.env.PUBLIC_URL}/phone.glb`);
    const modelRef = useRef();
    const { size } = useThree();
    const [isUserInteracting, setIsUserInteracting] = useState(false);

    const scaleValue = window.innerWidth > 480 ? 40 : window.innerWidth > 360 ? 30 : window.innerWidth > 240 ? 25 : window.innerWidth > 190 ? 20 : 13;

    useEffect(() => {
        /*console.log(size);
        console.log(window.innerWidth);*/
    }, [size]);

    useFrame(() => {
        if (modelRef.current && !isUserInteracting) {
            modelRef.current.rotation.y += 0.005;
        }
    });
    return (
        <>
            <primitive ref={modelRef} object={gltf.scene} scale={scaleValue} />
            <OrbitControls
                enableZoom={false}
                enablePan={false}
                onStart={() => setIsUserInteracting(true)}
                onEnd={() => setIsUserInteracting(false)}
            />
        </>
    );
};

useGLTF.preload(`${process.env.PUBLIC_URL}/phone.glb`);

const ContactPage = () => {
    const { active } = useProgress();

    useEffect(() => {
        const section = document.querySelector("#contact");
        if (section) {
            const navbarHeight = 50;
            const sectionTop = section.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({
                top: sectionTop - navbarHeight,
                behavior: "smooth"
            });
        }
    }, []);

    return (
        <div
            className="container d-flex flex-column align-items-center"
            style={{
                paddingTop: "200px",
                minHeight: "100vh",
                color: "white",
                gap: "50px",
            }}
        >
            <header id="contact" className="contact-title"
                style={{
                    fontWeight: "bold",
                    textShadow: "rgba(0, 0, 0, 0.35) 0px 5px 40px",
                }}
            >
                Contact
            </header>
            <div
                className="contact-content row"
                style={{
                    gap: "40px",
                    width: "100%",
                }}
            >
                <div
                    className="contact-left col-8 d-flex flex-column justify-content-center"
                    style={{
                        gap: "20px",
                    }}
                >
                    <h2 style={{ fontSize: "28px", fontWeight: "bold" }}>
                        Open for opportunities
                    </h2>
                    <p>
                        Have an exciting project you need help with?
                        <br />
                        Send me an email or contact me via instant message!
                    </p>
                    <a href="mailto:contact@dall.dev" target="_blank" rel="noopener noreferrer" className="email-btn">
                        <span className="svg-container"></span>
                        <span className="email-content" style={{ wordBreak: "break-word" }}>
                            <FaEnvelope />
                            contact@dall.dev
                        </span>
                        <span className="bg email"></span>
                    </a>

                    <div className="social-buttons-container d-flex">
                        <a href="https://linkedin.com/in/dallas-abeya" target="_blank" rel="noopener noreferrer" className="contact-btn linkedin">
                            <span className="svg-container">
                                <FaLinkedin/>
                            </span>
                            <span className="bg linkedin"></span>
                        </a>
                        <a href="https://github.com/DallasJr" target="_blank" rel="noopener noreferrer" className="contact-btn github">
                            <span className="svg-container">
                                <FaGithub/>
                            </span>
                            <span className="bg github"></span>
                        </a>
                        <a href="https://discordapp.com/users/681999446376185923" target="_blank" rel="noopener noreferrer" className="contact-btn discord">
                            <span className="svg-container">
                                <FaDiscord/>
                            </span>
                            <span className="bg discord"></span>
                        </a>
                    </div>
                </div>

                <div
                    className="contact-right col-3 mx-auto d-flex flex-column justify-content-center position-relative"
                    style={{
                        maxWidth: "500px",
                        width: "100%",
                    }}
                >
                    {active && (
                        <div className="skeleton-canvas position-absolute top-50 start-50 translate-middle" />
                    )}
                    <Canvas className="interactive" camera={{ position: [0, 5, 5] }}>
                        <ambientLight intensity={3} />
                        <directionalLight
                            position={[5, 5, 5]}
                            intensity={10}
                            color={"#f3ad7e"}
                        />
                        <Suspense fallback={null}>
                            <Model />
                        </Suspense>
                    </Canvas>
                </div>
            </div>
        </div>
    );
};

export default ContactPage;
